import * as dto from 'client/dto';
import { EsriPackages } from 'models/common-map-types';
import { GeoshapeAugmentedVM } from 'models/GeonameModels';

export function createOutbreakPinGraphic(
  esriPackages: EsriPackages,
  item: GeoshapeAugmentedVM<dto.EventLocationModel>
) {
  const { Point, Graphic } = esriPackages;
  const {
    x,
    y,
    geonameId,
    locationType,
    locationName,
    data: {
      caseCounts: { reportedCases, deaths },
    },
  } = item;
  const graphic = new Graphic(new Point({ x, y }));
  graphic.setAttributes({
    GEONAME_ID: geonameId,
    REPORTED_CASES: reportedCases,
    DEATHS: deaths,
    LOCATION_NAME: locationName,
    LOCATION_TYPE: locationType,
  });

  return graphic;
}

// TODO: 304aff45: duplicate functions? (except here "shape" is lowercase)
export function createOutbreakOutlineGraphic(
  esriPackages: EsriPackages,
  input: GeoshapeAugmentedVM<dto.EventLocationModel>
) {
  const { Polygon, Graphic } = esriPackages;
  const {
    shape,
    data: {
      caseCounts: { reportedCases },
    },
  } = input;
  const graphic = new Graphic(
    new Polygon({
      rings: shape,
      spatialReference: { wkid: 4326 },
    })
  );
  graphic.setAttributes({
    REPORTED_CASES: reportedCases,
  });
  return graphic;
}

export function GeoshapeVM2EsriGraphics(
  esriPackages: EsriPackages,
  shapes: GeoshapeAugmentedVM<dto.EventLocationModel>[]
) {
  const outlineGraphics = shapes
    .filter(s => s.isPolygon)
    .map(s => createOutbreakOutlineGraphic(esriPackages, s));
  const riskGraphics = shapes.map(s => createOutbreakPinGraphic(esriPackages, s));
  const iconGraphics = shapes.map(s => createOutbreakPinGraphic(esriPackages, s));

  return {
    outlineGraphics,
    riskGraphics,
    iconGraphics,
  };
}
